import axios from "axios";
const itemsPerPage = 25;
let currentPage = 0;
let allData = [];

export async function jsonData(currentPage) {
  console.log("jsonData");
  try {
    const data = await axios.get("./dataOpenLibrary.json");
    allData = data.data.docs;
  } catch (err) {
    console.log("Error fetching data");
  }
  const hasImages = allData.filter(
    (item) => item.cover_edition_key != undefined,
  );



  const results = hasImages.map((item) => {
    const imageLink = `https://covers.openlibrary.org/b/olid/${item.cover_edition_key}-L.jpg`;

    const bookObj = {
      img: imageLink,
      amazon: item.id_amazon ? item.id_amazon[0] : "",
      title: item.title,
      librivox: "",
    };
    console.log(bookObj)
    return bookObj;
  });

  return displayData(currentPage, results);
}

function totalPages() {
  return Math.ceil(allData.length / itemsPerPage);
}

export async function displayData(currentPage, results) {
  const start = (currentPage - 1) * itemsPerPage;

  const end = start + itemsPerPage;
  const itemsOnPage = await results.slice(start, end); // Slice the array

  return itemsOnPage;
}

export function goToPage() {
  console.log("goToPage");
  currentPage++;
  return jsonData(currentPage);
}
